const CardModel = require('../../../../shared/sharedModels').StimulusCard;

const Constants = {
   SetCurrentCard: 'S_SetCurrentCard',
   SetCurrentCardField: 'S_SetCurrentCardField',
   SetCardList: 'S_SetCardList',
   AddTopicToCurrentCard: 'S_AddTopicToCurrentCard',
   RemoveTopicFromCurrentCard: 'S_RemoveTopicFromCurrentCard',
   AddEvidenceToCurrentCard: 'S_AddEvidenceToCurrentCard'
};

exports.StimulusCardReducer = (state={},action) =>{
   switch(action.type){
      case Constants.SetCurrentCard:
         return {...state, curCard: action.card};
      case Constants.SetCurrentCardField: {
         const curCard = state.curCard;
         const newCard = Object.assign({}, curCard, {[action.field]: action.value});
         return Object.assign({}, state, {curCard: new CardModel(newCard)});
      }
      case Constants.SetCardList:
         return {...state, cardList: action.cardList};
      case Constants.AddTopicToCurrentCard:{
         let newCard = {...state.curCard};
         let topics = state.curCard.topics.slice();
         topics.push(action.topic);
         newCard.topics = topics;
         return {...state, curCard: new CardModel(newCard)};
      }
      case Constants.RemoveTopicFromCurrentCard:{
         let curTopics = state.curCard.topics.slice();
         for(let i = 0; i < curTopics.length; i++){
            if(curTopics[i].idTopic === action.topic.idTopic){
               curTopics.splice(i,1);
               break;
            }
         }
         let newCard = {...state.curCard};
         newCard.topics = curTopics;
         return {...state, curCard: new CardModel(newCard)};
      }
      case Constants.AddEvidenceToCurrentCard:{
         let cards = state.curCard.evidenceCards.slice();
         cards.push(action.evidence);
         let newCard = {...state.curCard, evidenceCards: cards};
         return {...state, curCard: new CardModel(newCard)};
      }
      default:
         return state;
   }
};

const FunctionList = {};

FunctionList.setCurrentCard = (card) => {
   return{
      type: Constants.SetCurrentCard,
      card
   }
};

FunctionList.setCurrentCardField = (field, value) => {
   return{
      type: Constants.SetCurrentCardField,
      field,
      value
   }
};

FunctionList.setCardList = (cardList) => {
   return{
      type: Constants.SetCardList,
      cardList
   }
};

FunctionList.addTopicToCurrentCard = (topic) => {
   return{
      type: Constants.AddTopicToCurrentCard,
      topic
   }
};

FunctionList.removeTopicFromCurrentCard = (topic) => {
   return{
      type: Constants.RemoveTopicFromCurrentCard,
      topic
   }
};

FunctionList.addEvidenceToCurrentCard = (evidence) => {
   return{
      type: Constants.AddEvidenceToCurrentCard,
      evidence
   }
};

exports.FunctionList = FunctionList;
